export default __webpack_public_path__ + "static/media/SoftBank.28549071.svg";